export const investigationComplete = ({ context }) => !!context.investigationComplete;
export const hearingNoticeGiven = ({ context }) => !!context.hearingNoticeGiven;
export const decisionWithinPolicy = ({ context }) => !!context.decisionWithinPolicy;
//# sourceMappingURL=disciplinary-warning.js.map